import { NumberInputProps } from '@mantine/core';
import { mergeRefs } from '@mantine/hooks';
import { forwardRef, memo, Ref, useRef } from 'react';
import NumberInput from './NumberInput';

// This is a currency input.
function CurrencyInput(props: NumberInputProps, _ref: Ref<HTMLInputElement>) {
  const innerRef = useRef<HTMLInputElement | null>(null);

  const formatter = (value: string | undefined): string => {
    if (document.activeElement?.isSameNode(innerRef.current)) {
      return value ?? '';
    }
    return formatMoney(value);
  };

  const ref = mergeRefs(innerRef, _ref);

  return (
    <NumberInput
      formatter={formatter}
      parser={parseMoney}
      precision={2}
      hideControls
      {...props}
      ref={ref}
    />
  );
}

function formatMoney(value: string | undefined): string {
  const valueAsNumber = parseFloat(value ?? '');

  if (!Number.isNaN(valueAsNumber)) {
    const format = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    const formatted = format.format(valueAsNumber);
    return formatted;
  }
  return '';
}

function parseMoney(value: string | undefined): string | undefined {
  if (!value) return undefined;
  return value.replace(/\$\s?|(,*)/g, '');
}

export type CurrencyInputType = React.ForwardRefExoticComponent<
  NumberInputProps & React.RefAttributes<HTMLInputElement>
>;

// Separate for styled extension.
export default memo(
  forwardRef<HTMLInputElement, NumberInputProps>(CurrencyInput),
) as CurrencyInputType;
